<div>
  <div *ngIf="showModal" class="modal">
    <div class="modal-content">
      <h2 class="title">Podemos coletar cookies?</h2>
      <p class="content">Coletamos cookies para apresentar ofertas e condições personalizadas para você.
        Se clicar em aceitar, você concorda com isso. Você pode ler os <a href="/termos">Termos de Uso</a> ou acessar
        nossa <a href="/privacidade">Política de Privacidade</a>
      </p>
      <div class="button-group">
        <button class="reject" (click)="rejectCookies()">Não aceito</button>
        <button class="accept" (click)="acceptCookies()">Aceito</button>
      </div>
    </div>
  </div>
</div>